import React, { useEffect, useMemo, useRef, useState } from 'react'
import Slider from 'react-slick';
import LinkAccount from './LinkAccount';
import ManageAccount from './ManageAccount';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../Providers/LanguageContext';

const LinkManageAccount = () => {
    const { language } = useLanguage();
    const SliderRef = useRef()
    const location = useLocation();
    const getInitialSlideMemo = useMemo(() => {
        if (location?.state?.slideNo === 1) {
            return 1;
        }
        else return 0;
    }, [location])

    // For Slider Navigations..
    const goToSlide = (index) => {
        if (SliderRef.current) {
            SliderRef.current.slickGoTo(index);
        }
    };
     
    useEffect(()=>{
        window.scrollTo({top:'0',behavior:'instant'})
    },[])

    // for sliders
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        initialSlide: getInitialSlideMemo
    };

    const [linkedAccData, setLinkedAccData] = useState([]);
    const [callGetAcc, setCallGetAcc] = useState(false);
    const navigate = useNavigate()

    return (
        
        <section style={{
            background: 'linear-gradient(rgb(15, 36, 55), rgb(255, 255, 255))', padding: '20px 0px;'
        }}>

            <div className='container-fluid'>

                {/* <h3 className='BookLinkHading'>{language.book_keeper_manager} - {language.link_account}</h3> */}
                <div className='task_head'>{language.book_keeper_manager} - {language.link_account}</div>
                <div className='d-flex justify-center items-center gap-4 mt-3 navigation_buttons_wrapper'>
                    <button onClick={(() => {
                        goToSlide(0)
                    })} className='slctUser' style={{
                        background: 'rgb(136, 233, 132)',
                        fontWeight: '500',
                        color: '#0c2637'
                    }}
                    >Link Account</button>
                    <button onClick={(() => {
                        goToSlide(1)
                    })} className='slctUser' style={{
                        background: 'rgb(136, 233, 132)',
                        fontWeight: '500',
                        color: '#0c2637'
                    }}
                    >Manage Account</button>
                </div>

                <div className="chart-slide">
                    <div className="">
                        <Slider ref={SliderRef} {...settings}>
                            <div>
                                <LinkAccount
                                    setLinkedAccData={setLinkedAccData}
                                    callGetAcc={callGetAcc}
                                />
                            </div>
                            <div>
                                <ManageAccount
                                    linkedAccData={linkedAccData}
                                    setCallGetAcc={setCallGetAcc}
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default LinkManageAccount
